import React from "react";
import styles from "./LandingPageLayout.module.css";

interface LandingPageLayoutProps {
  children: React.ReactNode;
  gap?: number;
}

export const LandingPageLayout: React.FC<LandingPageLayoutProps> = ({
  children,
  gap = "0px",
}) => {
  return (
    <div
      className={styles.landingPageLayout}
      style={{
        gap: `${gap}`,
      }}
    >
      {children}
    </div>
  );
};

export default LandingPageLayout;
